import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Table from 'shared_components/search_patient_table';
import PageTitle from 'shared_components/page_title';
import SearchFormEdit from 'modules/main/lab_request/steps/search/form_for_edit';
import TableHeader from 'modules/main/lab_request/steps/search/table_header';
import { GLOBAL_TABLE_PAGE_SIZE } from 'global_config/constant-global';
import { LR_REQUEST_TYPE } from 'modules/main/lab_request/steps/constants';

function SearchPage(props) {
	const history = useHistory();
	const [patients, setPatients] = useState([]);
	const [pageSize, setPageSize] = useState(GLOBAL_TABLE_PAGE_SIZE);
	const [currentPage, setCurrentPage] = useState(1);
	const [loading, setLoading] = useState(false);

	sessionStorage.setItem(LR_REQUEST_TYPE, 'view');

	// Reset to page 1 when search results change
	useEffect(() => {
		setCurrentPage(1);
	}, [patients.length]);

	// Reset to page 1 when page size changes
	useEffect(() => {
		setCurrentPage(1);
	}, [pageSize]);

	function handleTableDoubleClick(record) {
		const { requestHeader, ...persoInfo } = record;
		const { userID, requestDateTime, ...otherInfo } = record.requestHeader;

		history.push('/request/view/summary', { persoInfo, otherInfo });
	}

	function handlePaginationChange(page, pageSize) {
		setCurrentPage(page);
		setPageSize(pageSize);
	}

	return (
		<div>
			<PageTitle pageTitle="VIEW REQUEST" />
			<div className="space-y-md"></div>
			<SearchFormEdit populatePatients={setPatients} displayLoading={setLoading} />
			<div className="space-y-md"></div>
			<TableHeader
				pageSize={pageSize}
				pageTotal={patients.length}
				currentPage={currentPage}
				handleChangeSize={setPageSize}
			/>
			<div className="space-y-sm"></div>
			<Table
				data={patients}
				pageSize={pageSize}
				currentPage={currentPage}
				loading={loading}
				handleDoubleClick={handleTableDoubleClick}
				onPaginationChange={handlePaginationChange}
			/>
		</div>
	);
}

export default SearchPage;
